<template>
  <div class="team-members__member team-members__current-user">
    <div class="team-members__member-avatar">
      <q-avatar size="42px" color="primary" text-color="secondary" class="team-members__avatar">
        {{ user.name ? user.name.charAt(0).toUpperCase() : 'U' }}
      </q-avatar>
    </div>
    <div class="team-members__member-info">
      <p class="team-members__member-name">{{ user.name }}</p>
      <p class="team-members__member-email">{{ user.email }}</p>
    </div>
    <div class="team-members__member-role">
      <div class="team-members__badge-wrapper">
        <q-badge class="team-members__badge" color="primary" text-color="secondary" label="Admin" />
        <div class="team-members__custom-tooltip">
          <div class="team-members__tooltip-arrow"></div>
          <div class="team-members__tooltip-content"><strong>Admin:</strong> full access to all features, billing, and team management</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CurrentUserItem',
  props: {
    user: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import './team-members-styles.scss';
</style>
